import { setSliceActiveColor, setSliceSelectColorList } from '../slices/FJSliceColorCommon';

const FJActionColorCommon = {
    setActiveColorAction: function (color) {
        return dispatch => {
            dispatch(setSliceActiveColor(color));
        };
    },

    /**
     * 添加颜色到选择列表
     * @param {string} color - 颜色值
     */
    addSelectColorListAction: function (color) {
        return (dispatch, getState) => {
            const { selectColorList, defaultColorList } = getState().colorCommon;

            if (!selectColorList.includes(color) && !defaultColorList.includes(color)) {
                const newSelectColorList = [...selectColorList];
                newSelectColorList.unshift(color);
                dispatch(setSliceSelectColorList(newSelectColorList));
            }
        };
    },

    /**
     * 移除颜色
     * @param {string} color - 颜色值
     */
    removeSelectColorListAction: function (color) {
        return (dispatch, getState) => {
            const { selectColorList } = getState().colorCommon;
            const newSelectColorList = selectColorList.filter(item => item !== color);
            dispatch(setSliceSelectColorList(newSelectColorList));
        };
    },
};

export default FJActionColorCommon;
